module.exports = __webpack_public_path__ + "assets/img/d5db33f23eed19e2cb02a6391564d54f.png";